
import { Event, SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';
import { MediaClipActionOptions, MediaclipActions } from 'sdk/composable-commerce/types/actions/MediaClipActions';


export const MediaclipEventNames = {
  userTokenFetched: 'mediaclipUserTokenFetched',
  tokenRenewed: 'mediaclipTokenRenewed',
  redirectRequired: 'mediaclipRedirectRequired',
  projectCreated: 'mediaclipProjectCreated',
  projectCloned: 'mediaclipProjectCloned',
  uploadBatchPhotos: 'UploadMediaclipBatchPhotosAction'
} as const;

export const getMediaClipActions = (sdk: SDK<ComposableCommerceEvents>): MediaclipActions => {
  return {
    getUserToken: async (options: MediaClipActionOptions = {}) => {
      const response = await sdk.callAction<any>({
        actionName: 'mediaclip/get-user-token',
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      if (!response.isError && response.data?.userToken) {
        sdk.trigger(
          new Event({
            eventName: MediaclipEventNames.userTokenFetched,
            data: { userToken: response.data.userToken },
          }),
        );
      }

      return response;
    },

    renewToken: async (options: MediaClipActionOptions = {}) => {
  const response = await sdk.callAction<{ token?: string; redirectUrl?: string }>({
    actionName: 'mediaclip/renew-token',
    parallel: options.parallel,
    customHeaderValue: options.customHeaderValue,
    serverOptions: options.serverOptions,
  });

  if (!response.isError && response.data) {
    const data = response.data;

    if (data.redirectUrl) {
      sdk.trigger(
        new Event({
          eventName: MediaclipEventNames.redirectRequired,
          data: { redirectUrl: data.redirectUrl },
        }),
      );
    }

    if (data.token) {
      sdk.trigger(
        new Event({
          eventName: MediaclipEventNames.tokenRenewed,
          data: { token: data.token },
        }),
      );
    }
  }

  return response;
},


    createProject: async (payload: any, options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {}) => {
      const response = await sdk.callAction<any>({
        actionName: 'mediaclip/create-project',
        payload,
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      if (!response.isError && response.data?.projectId) {
        sdk.trigger(
          new Event({
            eventName: MediaclipEventNames.projectCreated,
            data: {
              projectId: response.data.projectId,
              productId: payload?.productId,
            },
          }),
        );
      }

      return response;
    },

    getBatchBeautyshots: async (payload: { beautyshots: any[] }, options: MediaClipActionOptions = {}) => {
      const response = await sdk.callAction<any>({
        actionName: 'mediaclip/get-batch-beautyshots',
        payload,
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      return response;
    },

    cloneProject: async (
  payload: { originalProjectId: string },
  options: {
    parallel?: boolean;
    customHeaderValue?: string;
    serverOptions?: ServerOptions;
  } = {},
) => {
  const response = await sdk.callAction<any>({
    actionName: 'mediaclip/clone-project',
    payload,
    parallel: options.parallel,
    customHeaderValue: options.customHeaderValue,
    serverOptions: options.serverOptions,
  });

  if (!response.isError && response.data?.projectId) {
    sdk.trigger(
      new Event({
        eventName: MediaclipEventNames.projectCloned,
        data: {
          projectId: response.data.projectId,
          originalProjectId: payload.originalProjectId,
        },
      }),
    );
  }

  return response;
},

uploadBatchPhotos: async (
  payload: { token: string; photos: Array<{ url: string; originalFilename?: string,type?:string }> },
  options: MediaClipActionOptions = {},
) => {
  return sdk.callAction<any>({
    actionName: 'mediaclip/photo-upload',
    payload,
    parallel: options.parallel,
    customHeaderValue: options.customHeaderValue,
    serverOptions: options.serverOptions,
  });
},

    getProjectsList: async (payload: any, options: MediaClipActionOptions = {}) => {
      const response = await sdk.callAction<any>({
        actionName: 'mediaclip/get-projects',
        payload,
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      return response;
    },
  };
};
